import React, { createContext, useContext, useState, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const ClientThemeContext = createContext(null);

export const ClientThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        return localStorage.getItem('clientTheme') || 'light';
    });

    const toggleTheme = () => {
        setMode((prevMode) => {
            const nextMode = prevMode === 'light' ? 'dark' : 'light';
            localStorage.setItem('clientTheme', nextMode);
            return nextMode;
        });
    };

    const theme = useMemo(() => {
        return createTheme({
            palette: {
                mode,
                primary: {
                    main: '#1565c0',
                },
                secondary: {
                    main: '#00796b',
                },
                background: {
                    default: mode === 'dark' ? '#0f172a' : '#f5f7fb',
                    paper: mode === 'dark' ? '#1e293b' : '#ffffff',
                },
                text: {
                    primary: mode === 'dark' ? '#f8fafc' : '#1e293b',
                    secondary: mode === 'dark' ? '#94a3b8' : '#64748b',
                },
                divider: mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',
            },
            typography: {
                fontFamily: '"Outfit", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            },
            components: {
                MuiButton: {
                    styleOverrides: {
                        root: {
                            textTransform: 'none',
                            borderRadius: 8,
                        },
                    },
                },
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 12,
                            boxShadow: mode === 'dark'
                                ? '0 4px 6px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.3)'
                                : '0 4px 6px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.08)',
                        },
                    },
                },
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none',
                        },
                    },
                },
            },
        });
    }, [mode]);

    return (
        <ClientThemeContext.Provider value={{ mode, toggleTheme }}>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </ClientThemeContext.Provider>
    );
};

export const useClientTheme = () => {
    const context = useContext(ClientThemeContext);
    if (!context) {
        throw new Error('useClientTheme debe utilizarse dentro de un ClientThemeProvider');
    }
    return context;
};
